<template>
	<div id="app">
		<video id="my-video" class="video-js vjs-default-skin" controls preload="auto">
			<!-- <source src="http://192.168.0.107:7002/live/stream.m3u8" type="application/x-mpegURL" /> -->
			<source src="https://livertc.wzhyt.cn/live/movie.m3u8" type="application/x-mpegURL" />
			<!-- <source src="rtmp://127.0.0.1/live/stream" type="application/x-mpegURL" /> -->
		</video>

	</div>
</template>

<script>
	import 'video.js/dist/video-js.css'
	import videojs from "video.js";
	import "videojs-contrib-hls";


	export default {
		name: 'app',
		mounted() {
			this.getVideo()
		},
		methods: {
			getVideo() {
				videojs(
					"my-video", {
						bigPlayButton: true,
						textTrackDisplay: true,
						posterImage: true,
						errorDisplay: true,
						controlBar: true
					},
					function() {
						this.play();
					}
				)
			}
		}

	}
</script>

<style>
	* {
		padding: 0;
		margin: 0;
		box-sizing: border-box;
		overflow: hidden;
	}

	#my-video {
		width: 100vw;
		height: 100vh;
	}
</style>